(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["clothing-store-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    const tagName = 'cs-delivery-24-48';
    if (customElements.get(tagName)) return;

    const DAY = 24 * 60 * 60 * 1000;

    customElements.define(tagName, class extends HTMLElement {
      connectedCallback() {
        if (this.timer) clearInterval(this.timer);

        if (this.onReady) {
          document.removeEventListener('DOMContentLoaded', this.onReady);
        }

        this.onReady = () => {
          if (!this.isConnected) return;

          this.renderDates();
          clearInterval(this.timer);
          this.timer = setInterval(() => this.renderDates(), 60000);
        };

        if (document.readyState === 'loading') {
          document.addEventListener(
            'DOMContentLoaded',
            this.onReady,
            { once: true }
          );
        } else {
          this.onReady();
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);

        if (this.onReady) {
          document.removeEventListener('DOMContentLoaded', this.onReady);
        }
      }

      renderDates() {
        const order = this.querySelector('[data-cs-order]');
        const delivery = this.querySelector('[data-cs-delivery]');

        if (!order && !delivery) return;

        try {
          if (!this.dateFormatter) {
            this.dateFormatter = new Intl.DateTimeFormat('fr-FR', {
              timeZone: 'Africa/Casablanca',
              weekday: 'short',
              day: 'numeric',
              month: 'short'
            });
          }

          const now = Date.now();

          if (order) {
            order.textContent = this.dateFormatter.format(now);
          }

          if (delivery) {
            const start = this.dateFormatter.format(now + DAY);
            const end = this.dateFormatter.format(now + 2 * DAY);

            delivery.textContent = `${start} – ${end}`;
          }
        } catch (error) {
          if (order) order.textContent = 'Aujourd’hui';
          if (delivery) delivery.textContent = 'Sous 24 à 48 h';
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-store-fabric-care"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cs-fabric-care')) return;
    customElements.define('cs-fabric-care', class extends HTMLElement {
      connectedCallback() {
        // A second copy of this section is upgraded before its children are parsed; wait for them.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
          return;
        }
        this.init();
      }
      init() {
        if (this.dataset.bound) return;
        this.dataset.bound = '1';
        const multiple = this.dataset.multiple === 'true';
        const toggles = Array.from(this.querySelectorAll('[data-cs-toggle]'));
        toggles.forEach((btn) => {
          btn.addEventListener('click', () => {
            const item = btn.closest('.cs__fb-item');
            const willOpen = !item.classList.contains('is-open');
            if (!multiple) {
              toggles.forEach((other) => {
                if (other === btn) return;
                other.closest('.cs__fb-item').classList.remove('is-open');
                other.setAttribute('aria-expanded', 'false');
              });
            }
            item.classList.toggle('is-open', willOpen);
            btn.setAttribute('aria-expanded', String(willOpen));
          });
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-store-trust-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cs-trust-bar')) return;
    customElements.define('cs-trust-bar', class extends HTMLElement {
      connectedCallback() {
        // Si le composant est chargé avant ses enfants, attendre la fin du chargement.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
          return;
        }
        this.init();
      }
      init() {
        const root = this.querySelector('[data-cs-root]');
        if (!root) return;
        // Traduire les anciens textes anglais déjà enregistrés dans l'éditeur.
        // Les textes personnalisés sont conservés tels quels.
        const oldDefaults = {
          'Free delivery': 'Livraison gratuite',
          'Livraison offerte': 'Livraison gratuite',
          'Over 200 AED, 1 to 3 days': 'Sans minimum d’achat',
          'Pour plus de 200 AED, sous 1 à 3 jours': 'Sans minimum d’achat',
          'Cash on delivery': 'Paiement à la livraison',
          'Pay when it arrives': 'Payez à la réception',
          '14-day exchange': 'Retour sous 7 jours',
          'Échange sous 14 jours': 'Retour sous 7 jours',
          'Collected from your door': 'Retour possible sous 7 jours',
          'Collecte à domicile': 'Retour possible sous 7 jours'
        };
        root.querySelectorAll('.cs__tb-title, .cs__tb-text').forEach((element) => {
          const original = element.textContent.trim();
          if (Object.prototype.hasOwnProperty.call(oldDefaults, original)) {
            element.textContent = oldDefaults[original];
          }
        });
        if (!('IntersectionObserver' in window)) { root.classList.add('is-visible'); return; }
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              root.classList.add('is-visible');
              this.io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        this.io.observe(root);
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-store-whatsapp"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cs-whatsapp')) return;
    customElements.define('cs-whatsapp', class extends HTMLElement {
      connectedCallback() {
        // Attendre le chargement du DOM si les enfants du bloc ne sont pas encore disponibles.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
          return;
        }
        this.init();
      }
      init() {
        this.link = this.querySelector('[data-cs-link]');
        if (!this.link) return;
        const data = this.querySelector('[data-cs-variants]');
        try { this.variants = data ? JSON.parse(data.textContent) : {}; } catch (e) { this.variants = {}; }

        this.link.addEventListener('click', () => { this.link.href = this.buildHref(); });
        this.link.addEventListener('mouseenter', () => { this.link.href = this.buildHref(); });
        this.link.addEventListener('focus', () => { this.link.href = this.buildHref(); });

        if (this.dataset.showStatus === 'true') {
          this.updateStatus();
          this.statusTimer = setInterval(() => this.updateStatus(), 60000);
        }
      }
      disconnectedCallback() {
        clearInterval(this.statusTimer);
      }
      currentVariantId() {
        const scope = this.closest('product-info, [data-product-id], .product, section') || document;
        const input = scope.querySelector('form[action*="/cart/add"] [name="id"]')
          || document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (input && input.value) return input.value;
        const param = new URLSearchParams(window.location.search).get('variant');
        return param || null;
      }
      buildHref() {
        const d = this.dataset;
        const id = this.currentVariantId();
        const v = (id && this.variants[id]) || null;
        const first = Object.keys(this.variants)[0];
        const fallback = first ? this.variants[first] : { title: '', price: '' };
        const variant = v || fallback;
        let url = d.url;
        if (id) url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id;
        const variantTitle = variant.title === 'Default Title' ? '' : variant.title;
        const text = (d.template || '')
          .replace(/\{product\}/g, d.title)
          .replace(/\{variant\}/g, variantTitle)
          .replace(/\{price\}/g, variant.price)
          .replace(/\{url\}/g, url)
          .replace(/\(\s*\)/g, '')
          .replace(/[ \t]{2,}/g, ' ');
        return 'https://wa.me/' + d.phone + '?text=' + encodeURIComponent(text.trim());
      }
      updateStatus() {
        const d = this.dataset;
        const dot = this.querySelector('[data-cs-status]');
        const sub = this.querySelector('[data-cs-sub]');
        const offset = (parseFloat(d.offset) || 0) * 3600000;
        const hour = new Date(Date.now() + offset).getUTCHours();
        const open = parseInt(d.open, 10);
        const close = parseInt(d.close, 10);
        const isOpen = open === close ? true
          : open < close ? (hour >= open && hour < close)
          : (hour >= open || hour < close);
        if (dot) dot.classList.toggle('is-away', !isOpen);
        if (sub) {
          const text = isOpen ? d.online : d.away;
          if (text) sub.textContent = text;
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
